module.exports = __webpack_public_path__ + "img/graph-up.15c4ae99.svg";